export default __webpack_public_path__ + "static/media/nr.36029ddd.svg";